import React, { Component } from 'react';
import ExportLeadsReport from '../../ContactLeadsReport/ExportLeadsReport';
import DateRangePicker from '../../../customlib/DateRangePicker';
import { Box, CircularProgress, Grid, LinearProgress } from '@mui/material';
import { Search } from '@mui/icons-material';
import Global from '../../../customlib/Global';

class Filter extends Component {
    state = {  } 
    render() { 
        return (
            <Box>
                {/* <Grid container spacing={1}>
                    <Grid item textAlign={"right"} xs={10} sx={{borderRadius: 10, padding: 5}}>
                        <DateRangePicker onDateChanged={this.props.handleDateChanged} />
                    </Grid>
                    <Grid item xs={2} textAlign={"left"}>
                        <div onClick={() => {this.props.getMyCustomerToday()}} className="btn btn-primary" style={{padding: 8}}><Search /></div>
                    </Grid>
                </Grid> */}
                
                <Box sx={{mb: "15px"}}>
                    {this.props.children}
                    
                {
                    this.props.state.isLoading === true && <LinearProgress />
                }
                </Box>
            </Box>
        );
    }
}
 
export default Filter;